export default __webpack_public_path__ + "static/media/Flyers.89afc3c5.png";